module.exports = __webpack_public_path__ + "static/media/SV1.749618dc.jpg";